var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"504aae452b92f7aa056060ae20c3efa089d59e38"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["reze-contra-o-comunismo@ipco-j6"]={id:"504aae452b92f7aa056060ae20c3efa089d59e38"};
      